<div class="help-drawer-backdrop" *ngIf="open" (click)="close()" aria-hidden="true"></div>

<aside
  class="help-drawer"
  [class.help-drawer--open]="open"
  role="dialog"
  aria-modal="true"
  [attr.aria-hidden]="!open"
  aria-labelledby="help-drawer-title">
  <div class="help-drawer__header">
    <h2 id="help-drawer-title" class="help-drawer__title">Help</h2>
    <button type="button" class="_circle-btn help-drawer__close" (click)="close()" aria-label="Close help">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="help-drawer__body">
    <label class="help-drawer__search-label" for="help-drawer-search">Search help</label>
    <input
      id="help-drawer-search"
      type="search"
      class="help-drawer__search"
      [(ngModel)]="searchQuery"
      placeholder="Search topics…"
      autocomplete="off"
      readonly
      title="Search coming soon" />

    <section class="help-drawer__section" aria-labelledby="help-tours-heading">
      <h3 id="help-tours-heading" class="help-drawer__section-title">Interactive help guides</h3>
      <div *ngIf="loading" class="help-drawer__muted" role="status">Loading help guides…</div>
      <p *ngIf="loadError" class="help-drawer__error" role="alert">{{ loadError }}</p>
      <ul *ngIf="!loading && !loadError" class="help-drawer__tour-list">
        <li *ngFor="let w of walkthroughs">
          <button type="button" class="help-drawer__tour" (click)="startTour(w)">
            <span class="help-drawer__tour-name">{{ w.name }}</span>
            <span class="help-drawer__tour-meta" *ngIf="w.description">{{ w.description }}</span>
          </button>
        </li>
        <li *ngIf="!walkthroughs.length" class="help-drawer__muted">{{ tourListEmptyMessage }}</li>
      </ul>
    </section>

    <section class="help-drawer__section" aria-labelledby="help-tips-heading">
      <h3 id="help-tips-heading" class="help-drawer__section-title">Suggested tips</h3>
      <div class="help-drawer__cards">
        <div class="help-drawer__card">
          <p class="help-drawer__card-title">Stay on top of follow-ups</p>
          <p class="help-drawer__card-body">Schedule follow-ups from the header so nothing slips through.</p>
        </div>
        <div class="help-drawer__card">
          <p class="help-drawer__card-title">Keep details current</p>
          <p class="help-drawer__card-body">Use edit mode to update enquiry and contact information.</p>
        </div>
      </div>
    </section>

    <section class="help-drawer__section" aria-labelledby="help-gs-heading">
      <h3 id="help-gs-heading" class="help-drawer__section-title">Getting started</h3>
      <ul class="help-drawer__checklist">
        <li *ngFor="let item of gettingStarted" class="help-drawer__checklist-item">
          <label class="help-drawer__check-row">
            <input type="checkbox" class="help-drawer__checkbox" [checked]="checklist[item.id]" (change)="toggleChecklist(item.id)" />
            <span class="help-drawer__check-label">{{ item.label }}</span>
          </label>
        </li>
      </ul>
    </section>
  </div>
</aside>
